import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_container_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    warehouse_guid: fromDatatype.GuidDataFieldInterface;
    warehouse_layout_guid: fromDatatype.GuidDataFieldInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    wms_item_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_guid: fromDatatype.GuidDataFieldInterface;
    qty_base: fromDatatype.NumericDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    qty_uom: fromDatatype.NumericDatatypeInterface;
    dim_x: fromDatatype.NumericDatatypeInterface;
    dim_y: fromDatatype.NumericDatatypeInterface;
    dim_z: fromDatatype.NumericDatatypeInterface;
    dim_w: fromDatatype.NumericDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    space_allocation_desc: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    machine_code: fromDatatype.VarcharDatatypeInterface;
    machine_code_image: fromDatatype.VarcharDatatypeInterface;
    machine_code_type: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    split_qty: fromDatatype.NumericDatatypeInterface;
}

export class bl_wms_container_hdr_RowClass implements bl_wms_container_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    warehouse_guid: fromDatatype.GuidDataFieldInterface;
    warehouse_layout_guid: fromDatatype.GuidDataFieldInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    wms_item_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_guid: fromDatatype.GuidDataFieldInterface;
    qty_base: fromDatatype.NumericDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    qty_uom: fromDatatype.NumericDatatypeInterface;
    dim_x: fromDatatype.NumericDatatypeInterface;
    dim_y: fromDatatype.NumericDatatypeInterface;
    dim_z: fromDatatype.NumericDatatypeInterface;
    dim_w: fromDatatype.NumericDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    space_allocation_desc: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    machine_code: fromDatatype.VarcharDatatypeInterface;
    machine_code_image: fromDatatype.VarcharDatatypeInterface;
    machine_code_type: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    split_qty: fromDatatype.NumericDatatypeInterface;
}